import { z } from "zod";

export const inquiriesUrlFiltersValidationSchema = z.object({
  userId: z.string().nullish(),
  name: z.string().nullish(),
  status: z.number().nullish(),
  startDate: z.string().nullish(),
  endDate: z.string().nullish(),
  visibilityFilter: z.number().nullish(),
});

export const inquiriesFiltersValidationSchema = z.object({
  agentId: z.string().uuid().nullish(),
  name: z.string().nullish(),
  createdAt: z.string().nullish(),
  status: z.number().nullish(),
  visibility: z.number().nullish(),
});

export const inquiriesReportFiltersValidationSchema = z.object({
  agentId: z.string().uuid().nullish(),
  name: z.string().nullish(),
  dateRange: z
    .object({
      startDate: z.string().nullish(),
      endDate: z.string().nullish(),
    })
    .nullish(),
  status: z.number().nullish(),
  visibility: z.number().nullish(),
});

export type InquiriesUrlFiltersFormInput = z.input<
  typeof inquiriesReportFiltersValidationSchema
>;

export type InquiriesFiltersFormInput = z.input<
  typeof inquiriesFiltersValidationSchema
>;
